import styled from 'styled-components';

export const Button = styled.button`
  padding: 10px 20px;
  background-color: orange;
  border: 2px solid black;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  color: #000;

  &:hover {
    background-color: #e08e0b;
  }
`;
